export default "__VITE_ASSET__BtQehRXI__"